import React, { useState } from 'react';
import { Card, Input, Button, Form, Alert, Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { adminApi } from '../lib/api';

const { Title } = Typography;

interface AdminLoginProps {
  onLogin: (adminKey: string) => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (values: { adminKey: string }) => {
    setLoading(true);
    setError(null);

    try {
      const isValid = await adminApi.validateAdminKey(values.adminKey);
      
      if (isValid) {
        localStorage.setItem('admin_key', values.adminKey);
        onLogin(values.adminKey);
      } else {
        setError('Invalid admin key. Please check your credentials.');
      }
    } catch (err) {
      setError('Failed to validate admin key. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <Card style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2}>Closet Admin</Title>
          <p style={{ color: '#666' }}>Enter your admin key to continue</p>
        </div>

        {error && (
          <Alert
            message={error}
            type="error"
            style={{ marginBottom: 16 }}
          />
        )}

        <Form
          name="admin_login"
          onFinish={handleSubmit}
          layout="vertical"
        >
          <Form.Item
            name="adminKey"
            label="Admin Key"
            rules={[
              { required: true, message: 'Please enter your admin key!' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Enter admin key"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              style={{ width: '100%' }}
            >
              Login
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 16, color: '#666' }}>
          <small>
            This admin key is required to access the Closet.style admin panel.
            Contact your system administrator if you don't have access.
          </small>
        </div>
      </Card>
    </div>
  );
};

export default AdminLogin;